
import { Component, inject, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import bootstrap from 'bootstrap';
import { LoginResult, TestLoginOptions } from '../../shared/models/auth.model';
import { SessionStoreRepository } from '../../shared/repositories/session.repository';
import { CommonModule } from '@angular/common';
import { OverlayLoadingSpinnerBorderComponent } from '../../shared/components/loading/overlay-loading-spinner-border/overlay-loading-spinner-border.component';
import { TranslocoService } from '@jsverse/transloco';
import { SessionDataService } from '../../shared/services/session.service';
import { SchemaRepository } from '../../shared/repositories/schema.repository';
import { ConsentStoreRepository } from '../../shared/repositories/consent.repository';

@Component({
  selector: 'app-login-guid',
  imports: [CommonModule, OverlayLoadingSpinnerBorderComponent, CommonModule],
  templateUrl: './login-guid.component.html'
})
export class LoginGuidComponent {
    loginIsError: boolean = false;
    modal: bootstrap.Modal | undefined;
    isLoading: WritableSignal<boolean> = signal(true);

      constructor(
        private router: Router,
        private route: ActivatedRoute

    ) { }
    
    private readonly sessionService = inject(SessionStoreRepository);
    private readonly schemaRepository = inject(SchemaRepository);
    private readonly consentStore = inject(ConsentStoreRepository)
    private readonly translocoService = inject(TranslocoService)
    private readonly sessionDataService = inject(SessionDataService)

    ngOnInit(): void {
        let loginGuid = <TestLoginOptions>this.route.snapshot.paramMap.get("option");
        
        if (this.sessionService.isLoggedIn()) {
            this.sessionDataService.doctorloginGuid(loginGuid).subscribe({
                    next: (loginResult: LoginResult) => {
                        if (loginResult.userInfo.providerNumber == this.sessionService.userInfo?.providerNumber) {
                            this.router.navigate(["/schemas"], { state: { archiveCpr: loginResult.archiveCpr } });
                        }
                        else{
                            this.logoutAndLogin(loginResult)
                        }
                    },
                    error: (message) => {
                        if (message.error) {
                            this.loginIsError = true;
                            this.isLoading.set(false)
                        }
                        this.router.navigate(["/welcome"]);
                    },
                });
        }
        else{
            this.authenticate(loginGuid);
        }
    }
    
    logoutAndLogin(loginResult: LoginResult){
        this.sessionService.resetStores();
        this.schemaRepository.resetStores();
        this.consentStore.clearConsentStore();
        this.sessionService.updateStore(loginResult)
        this.router.navigate(["/schemas"], { state: { archiveCpr: loginResult.archiveCpr } });
    }

    authenticate(loginGuid: string){
        this.loginIsError = false;
        if (!this.sessionService.isLoggedIn()) {
            if (loginGuid) {
                this.sessionService.doctorLoginWithGuid$(loginGuid)?.subscribe({
                    next: (loginResult: LoginResult) => {
                        if (loginResult) {
                            this.handleAuthenticatedRoute(loginResult.archiveCpr);
                        }
                    },
                    error: (message) => {
                        if (message.error) {
                            this.loginIsError = true;
                            this.isLoading.set(false)
                        }
                        alert(this.translocoService.translateObject('login.loginguiderror'));
                        this.router.navigate(["/welcome"]);
                    },
                });
            } else {
                this.loginIsError = false;
                this.isLoading.set(false)
            }
        } else {
            this.handleAuthenticatedRoute();
        }
    }
    
    handleAuthenticatedRoute(archiveCpr?: string) {
        setTimeout(() => {
            this.isLoading.set(false)
            sessionStorage.clear();
            this.router.navigate(["/authenticated"], { state: { archiveCpr } });
        }, 2000);
    }
  }

